import { colors, mediaQuery } from "../../../../../theme"

import { PriceView } from "../../../../../components/PriceView"
import { PropsWithTheme } from "../../../../../providers/StoreThemeProvider"
import { Trans } from "@lingui/macro"
import { i18n } from "@lingui/core"
import styled from "@emotion/styled/macro"
import { toLocalePrice } from "../../../../../utils"

type Props = {
  name: string
  price: string | import("react").ReactNode
  priceWithoutTax: number | null | undefined
}

export function ProductNamePrice({ name, price, priceWithoutTax }: Props) {
  return (
    <div data-testid="product-name-price">
      <Name data-testid="product-name">{name}</Name>
      <Price data-testid="product-price">{price}</Price>
      {priceWithoutTax && i18n.locale === "es-AR" && (
        <PriceWithoutTax>
          <Trans>Precio sin impuestos nacionales: </Trans>
          <PriceView price={toLocalePrice(priceWithoutTax, "ARS")} />
        </PriceWithoutTax>
      )}
    </div>
  )
}

const Name = styled.h1<PropsWithTheme>(props => ({
  fontSize: "2.6rem",
  fontWeight: "normal",
  wordBreak: "break-word",
  margin: 0,
  color: props.theme.colors.texts,
  fontFamily: props.theme.typographies.texts,

  [mediaQuery.desktop]: {
    marginBottom: "1.2rem",
  },
}))

const Price = styled.span<PropsWithTheme>(props => ({
  fontSize: "3.2rem",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  color: props.theme.colors.texts,
  fontFamily: props.theme.typographies.texts,

  "& sup": {
    fontSize: "2rem",
  },
}))

const PriceWithoutTax = styled.span<PropsWithTheme>(props => ({
  fontSize: "1.2rem",
  display: "flex",
  alignItems: "baseline",
  color: colors.greyMedium,
  fontFamily: props.theme.typographies.texts,
  gap: 2,

  "& sup": {
    fontSize: "1rem",
  },
}))
